import { AgentStatus } from 'models'
import type { CapabilitiesFactory } from '../types'
import { Subject } from '../types'

const GuestCapabilities: CapabilitiesFactory = (currentSession) => {
    if (!currentSession) {
        return []
    }
    return [
        // chats
        {
            subject: Subject.Chat,
            action: 'create',
        },
        {
            subject: Subject.Chat,
            action: 'read',
            condition: {
                createdBy: {
                    $eq: currentSession.user?.id,
                },
            },
        },
        {
            subject: Subject.Chat,
            action: 'update',
        },
        {
            subject: Subject.Chat,
            action: 'delete',
        },
        // agents
        {
            subject: Subject.Agent,
            action: 'read',
            condition: {
                status: {
                    $eq: AgentStatus.Active,
                },
            },
        },
        // feedbacks
        {
            subject: Subject.MessageFeedback,
            action: 'create',
        },
        {
            subject: Subject.MessageFeedback,
            action: 'read',
            condition: {
                createdBy: {
                    $eq: currentSession.user?.id,
                },
            },
        },
    ]
}
export default GuestCapabilities
